import { render, staticRenderFns } from "./HeaderOption.vue?vue&type=template&id=227bdd34&scoped=true"
import script from "./HeaderOption.vue?vue&type=script&lang=js"
export * from "./HeaderOption.vue?vue&type=script&lang=js"
import style0 from "./HeaderOption.vue?vue&type=style&index=0&id=227bdd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bdd34",
  null
  
)

export default component.exports